export default __webpack_public_path__ + "static/kursus-2009c0a090e71a1864fa864ad8c1d6cd.jpg";